export default "__VITE_ASSET__BpgXQdbz__"